import { render } from "./mainES.vue?vue&type=template&id=dfc6259a&scoped=true"
import script from "./mainES.vue?vue&type=script&lang=js"
export * from "./mainES.vue?vue&type=script&lang=js"

import "./mainES.vue?vue&type=style&index=0&id=dfc6259a&scoped=true&lang=less"

import exportComponent from "G:\\B030transformer\\demo (2)\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dfc6259a"]])

export default __exports__